<template>
	<div class="sliderScreeningPage visImage bigScreen" v-cloak v-loading="loading">
		<div class="sliderScreening latticeBg visImageTop breadth fz14">
			<div class="marl18">
				<span class="text marr8">时间</span>
				<div class="inlin sliderScreeningR">
					<el-date-picker
						class="time sliderDataCls"
						v-model="reportDate.data"
						type="monthrange"
						@change="datePicker"
						:picker-options="pickerOptions"
						unlink-panels
						range-separator="~"
						value-format="yyyy/MM"
						format="yyyy-MM"
						start-placeholder="开始时间"
						end-placeholder="结束时间"
					></el-date-picker>
				</div>
			</div>
			<div>
				<div class="center"><span class="fz14 marr20 dodgerBlue cur" @click="allReport()">查看所有抽样报告</span></div>
			</div>
		</div>
		<div class='supervisorPages doctorPage'>
			<div>
				<el-row :gutter="10" class="statisticsNum" v-if="hospitalResultList.HospitalSummary">
					<el-col :span="5">
						<div class="bgBox">
							<svg-icon class='titleSvg grey' icon-class='icon_core_frequency'></svg-icon>
							<div class="inlin nowrap">
								<span>质控次数</span>
								<span class="number blue">
									<numberGrow v-if="hospitalResultList.HospitalSummary.QCedCount>0&&destroy.flag" :value="hospitalResultList.HospitalSummary.QCedCount"></numberGrow>
									<span v-if="hospitalResultList.HospitalSummary.QCedCount==0">0</span> 次
									<span></span>
								</span>
							</div>
						</div>
					</el-col>
					<el-col :span="5">
						<div class="bgBox">
							<svg-icon class='titleSvg grey' icon-class='icon-home-total'></svg-icon>
							<div class="inlin nowrap">
								<span>抽样报告</span>
								<span class="number blue">
									<numberGrow v-if="hospitalResultList.HospitalSummary.TotalReportCount>0&&destroy.flag" :value="hospitalResultList.HospitalSummary.TotalReportCount"></numberGrow>
									<span v-if="hospitalResultList.HospitalSummary.TotalReportCount==0">0</span> 份
								</span>
							</div>
						</div>
					</el-col>
					<el-col :span="5">
						<div class="bgBox">
							<svg-icon class='titleSvg grey' icon-class='icon-home-peoplenew'></svg-icon>
							<div class="inlin nowrap">
								<span>审核医生</span>
								<span class="number blue">
									<numberGrow v-if="hospitalResultList.HospitalSummary.TotalFirstApproverCount>0&&destroy.flag" :value="hospitalResultList.HospitalSummary.TotalFirstApproverCount"></numberGrow>
									<span v-if="hospitalResultList.HospitalSummary.TotalFirstApproverCount==0">0</span> 人
								</span>
							</div>
						</div>
					</el-col>
					<el-col :span="5">
						<div class="bgBox">
							<svg-icon class='titleSvg grey' icon-class='icon_core_Firstdiagnosis'></svg-icon>
							<div class="inlin nowrap">
								<span>诊断医生</span>
								<span class="number blue">
									<numberGrow v-if="hospitalResultList.HospitalSummary.TotalSubmitterCount>0&&destroy.flag" :value="hospitalResultList.HospitalSummary.TotalSubmitterCount"></numberGrow>
									<span v-if="hospitalResultList.HospitalSummary.TotalSubmitterCount==0">0</span> 人
								</span>
							</div>
						</div>
					</el-col>
					<el-col :span="5">
						<div class="bgBox">
							<svg-icon class='titleSvg grey' icon-class='icon_core_technician'></svg-icon>
							<div class="inlin nowrap">
								<span>技师</span>
								<span class="number blue">
									<numberGrow v-if="hospitalResultList.HospitalSummary.TotalTechnicianCount>0&&destroy.flag" :value="hospitalResultList.HospitalSummary.TotalTechnicianCount"></numberGrow>
									<span v-if="hospitalResultList.HospitalSummary.TotalTechnicianCount==0">0</span> 人
								</span>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		<div>
			<el-row>
				<el-col :span="24">
					<el-row class="latticeBg">
						<ul class="tabs pdt8">
							<li :class="hospitalResultParameter.type == 2 ? 'tabsActive' : ''" @click="tabsSwitch(2)">报告</li>
							<li :class="hospitalResultParameter.type == 1 ? 'tabsActive' : ''" @click="tabsSwitch(1)">影像</li>
						</ul>
					</el-row>
				</el-col>
			</el-row>
			<el-row :gutter="12" class="mart10">
				<el-col :span="12">
					<centerscoreranking 
						class="latticeBg barSubpageHeight"
						:icon="'iconicon-Doctorsort2'"
						:title="'月度平均分排名'"
						:chartsType="'bar'"
						:colorList="['#2181FF']"
						centerscorerankingList="centerscorerankingList"
						:name="'centerscorerankingList'"
						:reportList="hospitalResultList.HospitalRank"
					></centerscoreranking>
				</el-col>
				<el-col :span="12">
					<centerscoreline
					class="latticeBg barSubpageHeight"
					:icon="'iconicon-DoctorLinechart'"
					:title="'月度平均分'"
					:chartsType="'line'"
					:colorList="['#F9721E','#248AFD','#30D9A0','#FAD443']"
					centerscorelineList="centerscorelineList"
					:name="'centerscorelineList'"
					:reportList="hospitalResultList.HospitalScore"
					>
					</centerscoreline>
				</el-col>
			</el-row>
			<el-row :gutter="12">
				<el-col :span="12">
					<proportion-table
					v-if="hospitalResultList"
					:list="hospitalResultList.HospitalUnqulifieds"
					:icon="'iconicon-Proportion'"
					:title="`月度不合格${titletext}`"
					:type="hospitalResultParameter.type"
					></proportion-table>
				</el-col>
				<el-col :span="12">
					<rule-table
					v-if="hospitalResultList"
					:list="hospitalResultList.AllItems"
					:allItems="hospitalResultList.AllItems"
					:seriousItems="hospitalResultList.SeriousItems"
					:icon="'iconicon-Deductpoints'"
					:title="'扣分细则'"
					:type="hospitalResultParameter.type"
					:tabType="tabType"
					></rule-table>
				</el-col>
			</el-row>
			<el-row :gutter="12">
				<el-col :span="24">
					<distribution
						:scoreAreaList='scoreAreaList'
						:icon="'iconicon-distribute'"
						:title="'分数及人员分布'"
						:type="hospitalResultParameter.type"
						:tabType="tabType"
					></distribution>
				</el-col>
			</el-row>
			<el-row :gutter="12">
				<el-col :span="24">
					<doctor-table
					:FirstApprovers="hospitalResultList.FirstApprovers"
					:Submitters="hospitalResultList.Submitters"
					:Technicians="hospitalResultList.Technicians"
					:icon="'iconicon-Doctorranking'"
					:title="`${titleTable}平均分排名`"
					:type="hospitalResultParameter.type"
					:tabType="tabType"
					></doctor-table>
				</el-col>
			</el-row>
		</div>
	</div>
</div>
</template>

<script>
import numberGrow from '../../components/tool/numberGrow'
import centerscoreranking from '@/components/supervisor/commponents/centralStatistics/centerscoreranking'
import centerscoreline from '@/components/supervisor/commponents/centralStatistics/centerscoreline'
import proportionTable from '@/components/supervisor/commponents/centralStatistics/proportionTable'
import ruleTable from '@/components/supervisor/commponents/centralStatistics/ruleTable'
import doctorTable from '@/components/supervisor/commponents/centralStatistics/doctorTable'
import distribution from '@/components/supervisor/commponents/centralStatistics/distribution'
export default {
	components: {
		numberGrow,
		centerscoreranking,
		centerscoreline,
		proportionTable,
		ruleTable,
		doctorTable,
		distribution
	},
	data() {
		return {
			loading:false,
			pickerOptions: {
				shortcuts: [
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [new Date(), new Date()]);
						}
					},
					{
						text: '今年至今',
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近六个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 6);
							picker.$emit('pick', [start, end]);
						}
					}
				],
				onPick: obj => {
					this.pickerMinDate = new Date(obj.minDate).getTime();
				},
				disabledDate: time => {
					if (this.pickerMinDate) {
						const day1 = 365 * 24 * 3600 * 1000;
						let maxTime = this.pickerMinDate + day1;
						let minTime = this.pickerMinDate - day1;
						return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
					} else {
						return time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
					}
				},
				hospitalGuid:'',
				titleTable:'医生',
				titletext:'报告',
				doctorList:[]
			},
		};
	},
	computed: {
		...Vuex.mapState('supervisor', ['destroy','setDateArr','slider']),
		...Vuex.mapState('breadcrumb', ['commonpars','breadLists']),
		...Vuex.mapState('centralStatistics', ['trigger', 'hospitalResultParameter','hospitalResultList','reportDate','scoreAreaList','tabType']),
		...Vuex.mapState('supervisor', ['HospitalAVGScoreArr','QualifiedPart', 'breadcrumbList', 'slider','GetReportListArr']),
		triggers() {
			return this.trigger.flag;
		}
	},
	watch:{
		triggers(old) {
			this.$nextTick(() => {
				if (old && this.tableFlag) {
					this.trigger.flag = false;
					this.init();
				}
			})
		}
	},
	activated() {
		this.init();
	},
	methods: {
		...Vuex.mapActions('centralStatistics', ['GetHospitalResult','GetScoreArea']),
		...Vuex.mapMutations('centralStatistics', ['changeType']),
		...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
		...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'settableLoading','setLoading', 'setBreadcrumbList']),
		init(){
			if (this.tabType) {
				this.changeType(false);
				if (this.HospitalAVGScoreArr.type == 2||this.HospitalAVGScoreArr.type == 4) {
					this.hospitalResultParameter.type = 2;
				}else if(this.HospitalAVGScoreArr.type == 3){
					this.hospitalResultParameter.type = 1;
				}
			}
			let index = Number(this.breadLists.breadList.length)==0?1:Number(this.breadLists.breadList.length);
			let user = JSON.parse(localStorage.getItem('user'));
			if (!user.stationName.contain('中心管理')) {
				const [start, end] = this.reportDate.data
				if (!start || !end) {
					this.reportDate.data = this.setDateArr.data;
				}
				this.breadLists.breadList[index - 1].name = this.commonpars.name;
			}else{
				this.hospitalResultParameter.hospitalGuid = user.regionIds.split(',').join('');
				const [start, end] = this.reportDate.data
				if (!start || !end) {
					this.reportDate.data = [this.slider.marks[0],this.slider.marks[99]];
				}
				this.hospitalResultParameter.type = 2;
			}
			// 时间取reportDate数据
			this.hospitalResultParameter.startdt = this.reportDate.data[0];
			this.hospitalResultParameter.enddt = this.reportDate.data[1];
			this.$nextTick(() => {
				let list = this.breadLists.breadList;
				this.breadLists.breadList = list.length>1?[list[list.length-1]]:list;
				this.breadLists.breadList[0].name = user.stationName == '中心管理'?'概览':this.breadLists.breadList[0].name;
				this.initFun(this.hospitalResultParameter.type);
			});
		},
		initFun(type){
			let scoreAreaType = 2;
			this.titletext = type==2?'报告':'影像';
			this.titleTable = type==2?'医生':'技师';
			this.hospitalResultParameter.type = type;
			if (type == 1) {
				scoreAreaType = 3;
			}else{
				scoreAreaType = this.HospitalAVGScoreArr.type;
			}
			this.loading = true;
			Promise.all([
				this.GetHospitalResult(),
				this.GetScoreArea({doctorType:scoreAreaType})
			]).then(res => {
				this.loading = false;
			})
			
		},
		datePicker(event){
			this.reportDate.data = event;
			this.hospitalResultParameter.startdt = event[0];
			this.hospitalResultParameter.enddt = event[1];
			this.tabsSwitch(this.hospitalResultParameter.type);
		},
		allReport(row, type) {
			this.setLoading(true);
			this.settableLoading(true);
			this.setTootipType(false);
			this.clearRow();
			this.currentChangesSecond(1);
			this.QualifiedPart.hospitalGuid = this.hospitalResultParameter.hospitalGuid;
			this.QualifiedPart.type = 'qualified';
			this.setBreadcrumbList();
			this.GetReportListArr.type = "医生列表";
			this.GetReportListArr.name = '';
			this.breadcrumbList.push(this.reportDate.data[0] + '-' + this.reportDate.data[1]);
			this.breadcrumbList.push('所有');
			this.$router.push("/home/supervisor/qualifiedTable");
			this.breadcrumbList.push("all");
		},
		tabsSwitch(type){
			this.initFun(type);
		},
		
	}
};
</script>

<style scoped="scoped">
	.bgBox{
		padding: 20px 2px !important;
	}
	.bigScreen .titleIcon{
		top: 0 !important;
	}
</style>
